import { render } from "./CardBannerList.vue?vue&type=template&id=2d1749ea&scoped=true&ts=true"
import script from "./CardBannerList.vue?vue&type=script&lang=ts"
export * from "./CardBannerList.vue?vue&type=script&lang=ts"

import "./CardBannerList.vue?vue&type=style&index=0&id=2d1749ea&lang=scss&scoped=true"

import exportComponent from "G:\\Runze\\rzhy_main_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d1749ea"]])

export default __exports__